import React, { useState, useContext } from "react";
import "./Clients.css";

import Modal from "react-bootstrap/Modal";
import ClientTable from "./clienttable";
import Form from "./Createform";
import LanguageContext from "../context/LanguageContext";

function Clients() {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const { t } = useContext(LanguageContext);
  return (
    <div className="Clients">
      <div className="main">
        <div>
          <button onClick={handleShow} className="AddClient">
            <i className="fa fa-user-plus" aria-hidden="true"></i> {t("clientsPage.addClient")}
          </button>
          <Modal show={show} onHide={handleClose} className="modal-lg">
            <Modal.Header closeButton>
              <Modal.Title>{t("clientsPage.addClient")}</Modal.Title>
            </Modal.Header>
            <Form parentFunction={handleClose} />
          </Modal>
        </div>
        <div className="testo">
          <ClientTable />
        </div>
      </div>
    </div>
  );
}

export default Clients;
